package com.example.mystybag.common.views

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import dev.icerock.moko.resources.compose.painterResource
import dev.icerock.moko.resources.compose.stringResource
import com.example.mystybag.common.extensions.Image
import com.example.mystybag.core.resources.SRC
import com.example.mystybag.common.resources.SR
import com.example.mystybag.common.ui.components.native.DefaultButton
import com.example.mystybag.common.ui.components.native.DefaultButtonType
import com.example.mystybag.common.ui.components.native.Texts
import com.example.mystybag.core.ui.theme.LocalTheme.p16
import com.example.mystybag.core.ui.theme.LocalTheme.p32
import com.example.mystybag.core.ui.theme.LocalTheme.p24

@Composable
fun RateAppBottomSheetView(onLaterClicked: () -> Unit, onRateUsClicked: () -> Unit) {
    Column(
        modifier            = Modifier.padding(horizontal = p16),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Image(
            modifier    = Modifier
                .fillMaxWidth()
                .padding(top = p24),
            painter     = painterResource(SRC.images.rate_us_image)
        )

        Texts.HeadlineSmall(
            stringResource(
            resource = SR.strings.enjoying_mystybag),
            textAlign = TextAlign.Center
        )
        Texts.BodyMedium(
            text      = stringResource(resource = SR.strings.enjoying_mystybag_mind_giving_us_a_5_star_rating_on_play_store),
            textAlign = TextAlign.Center,
            modifier  = Modifier.padding(vertical = p32))
        DefaultButton(
            caption  = stringResource(SR.strings.later),
            modifier = Modifier.padding(bottom = p16),
            type     = DefaultButtonType.SECONDARY,
            callback = onLaterClicked
        )
        DefaultButton(
            caption  = stringResource(SR.strings.rate_us_5_star),
            modifier = Modifier.padding(bottom = p16),
            callback = onRateUsClicked
        )
    }
}